<template>
  <div>
    <b-overlay
      :show="show"
      rounded="sm"
    >
      <template #overlay>
        <div class="text-center">
          <div class="h2 mb-0">
            <b-icon-watch
              font-scale="3"
              animation="cylon"
            />
          </div>
          <h2 class="text-dark">
            Procesando ....
          </h2>
        </div>
      </template>

      <b-card>
        <validation-observer ref="formCuote">
          <b-form>
            <!-- Fecha -->
            <b-form-group>
              <validation-provider
                v-slot="{ errors }"
                name="Fecha"
                rules="required"
              >
                <label for="cred_fecha">* Fecha:</label>
                <flat-pickr
                  id="cred_fecha"
                  v-model="cred_fecha"
                  class="form-control invoice-edit-input"
                  type="date"
                />
                <small class="text-danger">
                  {{ errors[0] }}
                </small>
              </validation-provider>
            </b-form-group>

            <!-- Valor -->
            <b-form-group>
              <validation-provider
                v-slot="{ errors }"
                name="Valor"
                rules="required"
              >
                <label for="cred_valor">* Valor:</label>
                <cleave
                  id="cred_valor"
                  v-model="cred_valor"
                  placeholder="Valor"
                  class="form-control"
                  :raw="false"
                  :options="optionsnumber.number"
                  style="text-align: right"
                  disabled
                />
                <small class="text-danger">
                  {{ errors[0] }}
                </small>
              </validation-provider>
            </b-form-group>

            <!-- Número de Cuotas -->
            <b-form-group>
              <validation-provider
                v-slot="{ errors }"
                name="Número de Cuotas"
                rules="required"
              >
                <label for="cred_cuotas">
                  * Número de Cuotas:
                </label>
                <b-form-input
                  id="cred_cuotas"
                  v-model="cred_cuotas"
                  type="number"
                  min="1"
                  placeholder="Número de cuotas"
                  disabled
                  @keypress="soloNumeros"
                  @paste="filtrarPegado"
                />
                <small class="text-danger">
                  {{ errors[0] }}
                </small>
              </validation-provider>
            </b-form-group>

            <!-- Comentario -->
            <b-form-group hidden>
              <label for="cred_msn">* Comentario:</label>
              <b-form-input
                id="cred_msn"
                v-model="cred_msn"
                placeholder="Comentario"
                :formatter="toUpperCase"
              />
            </b-form-group>

            <b-table
              v-if="tablaCuotas.length > 0"
              :items="tablaCuotas"
              :fields="camposTablaCuotas"
              striped
              hover
              responsive
              class="mb-3"
            >
              <template #cell(fecha)="data">
                <flat-pickr
                  v-model="data.item.fecha"
                  class="form-control form-control-sm"
                  type="date"
                />
              </template>

              <template #cell(valor)="data">
                <cleave
                  v-model="data.item.valor"
                  class="form-control form-control-sm"
                  :raw="false"
                  :options="optionsnumber.number"
                  style="text-align: right"
                  disabled
                />
              </template>
            </b-table>

            <div
              v-if="tablaCuotas.length > 0"
              class="d-flex justify-content-end mb-2"
            >
              <strong>
                Total: {{ formatMoneda(totalCuotas) }}
              </strong>
            </div>
          </b-form>
        </validation-observer>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
/* eslint-disable */
import { required } from '@validations'
import {
    BButton,
    BCard,
    BForm,
    BFormGroup,
    BFormInput,
    BIconWatch,
    BOverlay,
    BTable,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Cleave from 'vue-cleave-component'
import flatPickr from 'vue-flatpickr-component'

export default {
    components: {
        BOverlay,
        BIconWatch,
        BCard,
        BButton,
        BFormInput,
        flatPickr,
        Cleave,
        ValidationObserver,
        ValidationProvider,
        BFormGroup,
        BForm,
        BTable,
    },
    props: {
        contrato: {
            type: Object,
            required: true,
        },
    },
    setup() {
        return { required }
    },
    data() {
        return {
            userData: JSON.parse(localStorage.getItem('userData')),
            show: false,
            cred_contrato: '',
            cred_fecha: '',
            cred_valor: '',
            cred_cuotas: '',
            cred_msn: '',
            optionsnumber: {
                number: {
                    numeral: true,
                    numeralThousandsGroupStyle: 'thousand',
                },
            },
            tablaCuotas: [],
            camposTablaCuotas: [
                { key: 'numero', label: 'Cuota' },
                { key: 'fecha', label: 'Fecha' },
                { key: 'valor', label: 'Valor' },
            ],
            totalCuotas: 0,
        }
    },
    created() {
        // fecha
        const date = new Date()
        this.cred_fecha = `${date.getFullYear()}-${
            date.getMonth() + 1
        }-${date.getDate()}`

        this.cred_contrato = `${this.contrato.codigo || ''} - ${
            this.contrato.apenom || ''
        }`

        this.cred_valor = this.contrato.debito
        this.cred_cuotas = this.contrato.quota
        this.totalCuotas = this.contrato.debito

        this.reportData(this.contrato.idcontratocuota)
    },
    methods: {
        formatMoneda(value) {
            const val = (value / 1).toFixed(2).replace(',', '.')

            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        },

        roundNumber(value, precision) {
            if (Number.isInteger(precision)) {
                // Usar toFixed para asegurar exactamente el número de decimales deseado
                return parseFloat(value.toFixed(precision))
            }

            return Math.round(value)
        },

        toUpperCase(value) {
            return value.toUpperCase()
        },

        soloNumeros(event) {
            // Permitir solo teclas numéricas (0-9)
            const keyCode = event.keyCode ? event.keyCode : event.which
            if (keyCode < 48 || keyCode > 57) {
                event.preventDefault()
            }
        },

        filtrarPegado(event) {
            // Prevenir el pegado por defecto
            event.preventDefault()

            // Obtener el texto pegado
            const texto = (event.clipboardData || window.clipboardData).getData(
                'text'
            )

            // Verificar si solo contiene números
            if (/^\d+$/.test(texto)) {
                // Si solo contiene números, actualizar el modelo manualmente
                this.cred_cuotas = texto
            }
        },

        reportData(contratocuotaid) {
            this.show = true
            this.$http
                .get('/deferred-collection', {
                    params: {
                        idcontratocuota: contratocuotaid,
                    },
                })
                .then((response) => {
                    this.show = false
                    const collections = response.data.data

                    // Verificar si collections está vacío y mostrar un mensaje si es así
                    if (collections.length === 0) {
                        this.$swal({
                            title: 'Sin Datos',
                            text: 'No se encontraron colecciones diferidas.',
                            icon: 'info',
                            timer: 1500,
                        })
                    } else {
                        let i = 1
                        this.tablaCuotas = collections.map(
                            ({ date, amount }) => {
                                const numero = i
                                i += 1

                                return {
                                    numero,
                                    fecha: date,
                                    valor: amount,
                                }
                            }
                        )
                    }
                })
                .catch((error) => {
                    this.show = false
                    console.log(error)
                })
        },
    },
}
</script>
<style lang="scss" scoped>
@import '~@core/scss/base/pages/app-invoice.scss';
@import '~@core/scss/base/components/variables-dark';
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-wizard.scss';
.rowstyle {
    font-size: 11px;
    color: black;
}
</style>
